import React from "react";
import MaterialSymbol from "./MaterialSymbol";

const ICONS = {
    AccessTime: "schedule",
    AccountBalance: "account_balance",
    AccountCircle: "account_circle",
    Add: "add",
    AddAlert: "add_alert",
    AddCircleOutline: "add_circle",
    AddLocation: "add_location",
    Apps: "apps",
    Archive: "archive",
    ArrowBackIos: "arrow_back_ios",
    ArrowDownward: "arrow_downward",
    ArrowDropUp: "arrow_drop_up",
    ArrowForward: "arrow_forward",
    ArrowUpward: "arrow_upward",
    ArtTrack: "art_track",
    Assignment: "assignment",
    AttachMoney: "attach_money",
    AvTimer: "timer",
    BarChart: "bar_chart",
    BorderColor: "border_color",
    BugReport: "bug_report",
    Build: "build",
    Business: "business",
    CalendarToday: "calendar_today",
    Cancel: "cancel",
    CardTravel: "card_travel",
    Check: "check",
    CheckBox: "check_box",
    CheckCircle: "check_circle",
    CheckCircleOutline: "check_circle",
    ChevronRight: "chevron_right",
    Clear: "close",
    Close: "close",
    Cloud: "cloud",
    CloudDownload: "cloud_download",
    CloudUpload: "cloud_upload",
    Code: "code",
    Contacts: "contacts",
    CreateNewFolder: "create_new_folder",
    Dashboard: "dashboard",
    DateRange: "date_range",
    Delete: "delete",
    DeleteOutline: "delete",
    Description: "description",
    Dialpad: "dialpad",
    Dns: "dns",
    Dvr: "dvr",
    Edit: "edit",
    Email: "mail",
    EmojiObjects: "emoji_objects",
    Error: "error",
    ExpandLess: "keyboard_arrow_up",
    ExpandMore: "keyboard_arrow_down",
    Extension: "extension",
    Face: "face",
    Favorite: "favorite",
    FiberManualRecord: "radio_button_unchecked",
    FileCopy: "content_copy",
    FileCopyOutlined: "content_copy",
    Fingerprint: "fingerprint",
    FlightLand: "flight_land",
    FormatQuote: "format_quote",
    GetApp: "download",
    Gavel: "gavel",
    GridOn: "grid_on",
    Group: "group",
    HeadsetMic: "support_agent",
    HelpOutline: "help",
    Home: "home",
    Image: "image",
    Info: "info",
    InfoOutlined: "info",
    Input: "login",
    InsertDriveFile: "description",
    InsertDriveFileOutlined: "description",
    KeyboardArrowDown: "keyboard_arrow_down",
    KeyboardArrowLeft: "keyboard_arrow_left",
    KeyboardArrowRight: "keyboard_arrow_right",
    Language: "language",
    LibraryBooks: "library_books",
    LocalOffer: "local_offer",
    LocationOn: "location_on",
    Lock: "lock",
    LockOpen: "lock_open",
    MailOutline: "mail",
    Map: "map",
    Menu: "menu",
    Message: "chat",
    MonetizationOn: "attach_money",
    MoreVert: "more_vert",
    Notifications: "notifications",
    PermIdentity: "person",
    Person: "person",
    PersonAdd: "person_add",
    Payment: "payments",
    Place: "location_on",
    PriorityHigh: "priority_high",
    Print: "print",
    Publish: "upload",
    RateReview: "rate_review",
    Refresh: "refresh",
    Remove: "remove",
    Reply: "reply",
    RecordVoiceOver: "record_voice_over",
    RestoreSharp: "restore",
    Save: "save",
    Schedule: "schedule",
    Search: "search",
    Send: "send",
    Settings: "settings",
    ShoppingCart: "shopping_cart",
    Store: "store",
    Sync: "sync",
    Timeline: "timeline",
    Today: "today",
    Update: "update",
    ViewList: "view_list",
    Visibility: "visibility",
    VisibilityOff: "visibility_off",
    VpnKey: "key",
    Warning: "warning",
    Widgets: "widgets",
};

function createIcon(symbol) {
    const Icon = React.forwardRef(({ className, fontSize, style, ...rest }, ref) => (
        <MaterialSymbol
            ref={ref}
            className={className}
            style={{
                fontSize: fontSize === "small" ? 20 : fontSize === "large" ? 32 : undefined,
                ...style,
            }}
            {...rest}
        >
            {symbol}
        </MaterialSymbol>
    ));
    Icon.displayName = `MaterialSymbolIcon(${symbol})`;
    return Icon;
}

export const AccessTime = createIcon(ICONS.AccessTime);
export const AccountBalance = createIcon(ICONS.AccountBalance);
export const AccountCircle = createIcon(ICONS.AccountCircle);
export const Add = createIcon(ICONS.Add);
export const AddAlert = createIcon(ICONS.AddAlert);
export const AddCircleOutline = createIcon(ICONS.AddCircleOutline);
export const AddLocation = createIcon(ICONS.AddLocation);
export const Apps = createIcon(ICONS.Apps);
export const Archive = createIcon(ICONS.Archive);
export const ArrowBackIos = createIcon(ICONS.ArrowBackIos);
export const ArrowDownward = createIcon(ICONS.ArrowDownward);
export const ArrowDropUp = createIcon(ICONS.ArrowDropUp);
export const ArrowForward = createIcon(ICONS.ArrowForward);
export const ArrowUpward = createIcon(ICONS.ArrowUpward);
export const ArtTrack = createIcon(ICONS.ArtTrack);
export const Assignment = createIcon(ICONS.Assignment);
export const AttachMoney = createIcon(ICONS.AttachMoney);
export const AvTimer = createIcon(ICONS.AvTimer);
export const BarChart = createIcon(ICONS.BarChart);
export const BorderColor = createIcon(ICONS.BorderColor);
export const BugReport = createIcon(ICONS.BugReport);
export const Build = createIcon(ICONS.Build);
export const Business = createIcon(ICONS.Business);
export const CalendarToday = createIcon(ICONS.CalendarToday);
export const Cancel = createIcon(ICONS.Cancel);
export const CardTravel = createIcon(ICONS.CardTravel);
export const Check = createIcon(ICONS.Check);
export const CheckBox = createIcon(ICONS.CheckBox);
export const CheckCircle = createIcon(ICONS.CheckCircle);
export const CheckCircleOutline = createIcon(ICONS.CheckCircleOutline);
export const ChevronRight = createIcon(ICONS.ChevronRight);
export const Clear = createIcon(ICONS.Clear);
export const Close = createIcon(ICONS.Close);
export const Cloud = createIcon(ICONS.Cloud);
export const CloudDownload = createIcon(ICONS.CloudDownload);
export const CloudUpload = createIcon(ICONS.CloudUpload);
export const Code = createIcon(ICONS.Code);
export const Contacts = createIcon(ICONS.Contacts);
export const CreateNewFolder = createIcon(ICONS.CreateNewFolder);
export const Dashboard = createIcon(ICONS.Dashboard);
export const DateRange = createIcon(ICONS.DateRange);
export const Delete = createIcon(ICONS.Delete);
export const DeleteOutline = createIcon(ICONS.DeleteOutline);
export const Description = createIcon(ICONS.Description);
export const Dialpad = createIcon(ICONS.Dialpad);
export const Dns = createIcon(ICONS.Dns);
export const Dvr = createIcon(ICONS.Dvr);
export const Edit = createIcon(ICONS.Edit);
export const Email = createIcon(ICONS.Email);
export const EmojiObjects = createIcon(ICONS.EmojiObjects);
export const Error = createIcon(ICONS.Error);
export const ExpandLess = createIcon(ICONS.ExpandLess);
export const ExpandMore = createIcon(ICONS.ExpandMore);
export const Extension = createIcon(ICONS.Extension);
export const Face = createIcon(ICONS.Face);
export const Favorite = createIcon(ICONS.Favorite);
export const FiberManualRecord = createIcon(ICONS.FiberManualRecord);
export const FileCopy = createIcon(ICONS.FileCopy);
export const FileCopyOutlined = createIcon(ICONS.FileCopyOutlined);
export const Fingerprint = createIcon(ICONS.Fingerprint);
export const FlightLand = createIcon(ICONS.FlightLand);
export const FormatQuote = createIcon(ICONS.FormatQuote);
export const Gavel = createIcon(ICONS.Gavel);
export const GetApp = createIcon(ICONS.GetApp);
export const GridOn = createIcon(ICONS.GridOn);
export const Group = createIcon(ICONS.Group);
export const HeadsetMic = createIcon(ICONS.HeadsetMic);
export const HelpOutline = createIcon(ICONS.HelpOutline);
export const Home = createIcon(ICONS.Home);
export const Image = createIcon(ICONS.Image);
export const Info = createIcon(ICONS.Info);
export const InfoOutlined = createIcon(ICONS.InfoOutlined);
export const Input = createIcon(ICONS.Input);
export const InsertDriveFile = createIcon(ICONS.InsertDriveFile);
export const InsertDriveFileOutlined = createIcon(ICONS.InsertDriveFileOutlined);
export const KeyboardArrowDown = createIcon(ICONS.KeyboardArrowDown);
export const KeyboardArrowLeft = createIcon(ICONS.KeyboardArrowLeft);
export const KeyboardArrowRight = createIcon(ICONS.KeyboardArrowRight);
export const Language = createIcon(ICONS.Language);
export const LibraryBooks = createIcon(ICONS.LibraryBooks);
export const LocalOffer = createIcon(ICONS.LocalOffer);
export const LocationOn = createIcon(ICONS.LocationOn);
export const Lock = createIcon(ICONS.Lock);
export const LockOpen = createIcon(ICONS.LockOpen);
export const MailOutline = createIcon(ICONS.MailOutline);
export const Map = createIcon(ICONS.Map);
export const Menu = createIcon(ICONS.Menu);
export const Message = createIcon(ICONS.Message);
export const MonetizationOn = createIcon(ICONS.MonetizationOn);
export const MoreVert = createIcon(ICONS.MoreVert);
export const Notifications = createIcon(ICONS.Notifications);
export const PermIdentity = createIcon(ICONS.PermIdentity);
export const Person = createIcon(ICONS.Person);
export const PersonAdd = createIcon(ICONS.PersonAdd);
export const Payment = createIcon(ICONS.Payment);
export const Place = createIcon(ICONS.Place);
export const PriorityHigh = createIcon(ICONS.PriorityHigh);
export const Print = createIcon(ICONS.Print);
export const Publish = createIcon(ICONS.Publish);
export const RateReview = createIcon(ICONS.RateReview);
export const Refresh = createIcon(ICONS.Refresh);
export const Remove = createIcon(ICONS.Remove);
export const Reply = createIcon(ICONS.Reply);
export const RecordVoiceOver = createIcon(ICONS.RecordVoiceOver);
export const RestoreSharp = createIcon(ICONS.RestoreSharp);
export const Save = createIcon(ICONS.Save);
export const Schedule = createIcon(ICONS.Schedule);
export const Search = createIcon(ICONS.Search);
export const Send = createIcon(ICONS.Send);
export const Settings = createIcon(ICONS.Settings);
export const ShoppingCart = createIcon(ICONS.ShoppingCart);
export const Store = createIcon(ICONS.Store);
export const Sync = createIcon(ICONS.Sync);
export const Timeline = createIcon(ICONS.Timeline);
export const Today = createIcon(ICONS.Today);
export const Update = createIcon(ICONS.Update);
export const ViewList = createIcon(ICONS.ViewList);
export const Visibility = createIcon(ICONS.Visibility);
export const VisibilityOff = createIcon(ICONS.VisibilityOff);
export const VpnKey = createIcon(ICONS.VpnKey);
export const Warning = createIcon(ICONS.Warning);
export const Widgets = createIcon(ICONS.Widgets);
